import { render, staticRenderFns } from "./DoubleTapToConfirmButton.vue?vue&type=template&id=5cd78ccc&scoped=true&"
import script from "./DoubleTapToConfirmButton.vue?vue&type=script&lang=js&"
export * from "./DoubleTapToConfirmButton.vue?vue&type=script&lang=js&"
import style0 from "./DoubleTapToConfirmButton.vue?vue&type=style&index=0&id=5cd78ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd78ccc",
  null
  
)

export default component.exports